import { initTypeOfAccountForm } from '../../../../../Common/Resources/src_front/js/components/initTypeOfAccountForm';

window.addEventListener('DOMContentLoaded', function () {
    initTypeOfAccountForm();
});
